import { getHeaders } from "../utils";

export const APITransferPlanToInspire = async (companyId, bucketId, planId, url) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);
        const body = {
            planId: planId,
            url: url
        };

		const requestOptions = {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(body),
			redirect: 'follow'
		};
		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/hale/1.0/${companyId}/bucket/${bucketId}/url`, requestOptions);
        if (!response.ok) {
            throw new Error(`Error transferring plan to INSPIRE: ${response.statusText}`);
        }
    } catch (error) {
        console.error("APITransferPlanToInspire error:", error);
        throw error;
    }
}

export const APICreateInspireOrganization = async (companyId, data) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

		const requestOptions = {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(data),
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/hale/1.0/${companyId}/orgs`, requestOptions);
        if (!response.ok) {
            throw new Error(`Error creating INSPIRE organization: ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("APICreateInspireOrganization error:", error);
        throw error;
    }
}

export const APICreateNewBucketForPlan = async (companyId, planId) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ planId }),
            redirect: 'follow'
        };
        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/hale/1.0/${companyId}/bucket`, requestOptions);
        if (!response.ok) {
            throw new Error(`Error creating new bucket for plan: ${response.statusText}`);
        }
        const responseObject = await response.json();
        const bucketId = responseObject?.data.bucketId;
        if (!bucketId) {
            throw new Error("Bucket ID not found in response");
        }
        return bucketId;
    }
    catch (error) {
        console.error("APICreateNewBucketForPlan error:", error);
        throw error;
    }
}

export const APIAutoFillInspireBucket = async (companyId, planId) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow'
        };
        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/hale/1.0/${companyId}/plan/${[planId]}/autofill`, requestOptions);
        if (!response.ok) {
            throw new Error(`Error autofilling INSPIRE bucket: ${response.statusText}`);
        }
    } catch (error) {
        console.error("APIAutoFillInspireBucket error:", error);
        throw error;
    }
}

export const APIGetAllInspirePlans = async (companyId) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow'
        };
        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/integrations/1.0/${companyId}/inspireplans`, requestOptions);
        if (!response.ok) {
            throw new Error(`Error fetching INSPIRE plans: ${response.statusText}`);
        }
        const data = await response.json();
        return data?.data || [];
    } catch (error) {
        console.error("APIGetAllInspirePlans error:", error);
        throw error;
    }
}